import UserContext from "./context/UserContext";
import "./App.css";
import Home from "./components/Home/Home";
import { useEffect, useState } from "react";
import { HashRouter, Route, Routes } from "react-router-dom";
import Admin from "./components/Admin/Admin";
import Error404 from "./components/Error/Error404";
import Lealtad from "./components/Lealtad/Lealtad";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { client_id, id_face } from "./assets/constantes";
import { FacebookProvider } from "react-facebook";
//import Consulta from "./components/Admin/Consulta";
import Express from "./components/Express/Express";
import { useLocalStorage } from "usehooks-ts";
import RetryRegister from "./components/RetryRegister/RetryRegister";
import RetryRegisterExpress from "./components/Express/RetryRegisterExpress";
import MonitorTiendas from "./components/Monitor/Pages/MonitorTiendas";
import GeneralMonitor from "./components/Monitor/Pages/GeneralMonitor";
import WelcomeMinisoLover from "./components/Home/WelcomeMinisoLover";
import MonitorClients from "./components/Monitor/Pages/MonitorClients";
import LoginMonitor from "./components/Monitor/Pages/LoginMonitor";
import AdminMonitor from "./components/Monitor/Pages/AdminMonitor";

//los datos a obtener del formulario son:
//cuponType, email, gender, maritalStatus, materno, nameUser, newsLetter, paterno, privacy, tyc,
//userFenac, userPreferences, zipCode

const initialDataUser = {
  email: "default",
  cuponType: "",
  cuponCode: "",
  cuponVigencia: "",
  gender: "",
  maritalStatus: "",
  materno: "",
  nameUser: "",
  newsLetter: true,
  paterno: "",
  privacy: false,
  tyc: false,
  fenacUser: "",
  userFenac: "",
  userPreferences: [],
  zipCode: "",
  cityUser: "",
  stateUser: "",
  phoneUser: "",
  dataRegister: {},
  dataIsFounded: {},
  cancelRetraying: false,
  dataID: {
    idAptos: null,
    idCL: null,
  },
  succedRegister: false,
  registerComplete: false,
  errorMessage: "",
  duplicityAptos: false,
  duplicityCL: false,
  duplicityMF: false,
  estatus: "",
  userEnv: "",
};

const initialAdminUser = {
  user: "",
  logged: false,
};

const initialMonitorUser = {
  user: "",
  estatus: "",
  role: "",
  paises: [],
};

function App() {
  const [dataUser, setDataUser] = useState(initialDataUser);
  const [adminUser, setAdminUser] = useState(initialAdminUser);
  const [monitorUser, setMonitorUser] = useState(initialMonitorUser);
  const [dataMonitorLocalStorage, setDataMonitorLocalStorage] = useLocalStorage(
    "dataMonitorMiniso",
    initialMonitorUser
  );
  const [dataLocalStorage, setDataLocalStorage] = useLocalStorage(
    "dataUserMiniso",
    initialDataUser
  );

  useEffect(() => {
    // <!-- Google tag (gtag.js) -->

    const script = document.createElement("script");
    script.src = "https://www.googletagmanager.com/gtag/js?id=AW-706013356";
    script.async = true;
    document.body.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    gtag("js", new Date());

    gtag("config", "AW-706013356");
  }, []);

  useEffect(() => {
    if (dataUser.registerComplete) {
      console.log("registerComplete is TRUE:..");
      setDataUser({
        ...initialDataUser,
        pageReload: true,
      });
      //window.location.reload();
    }
    return;
  }, [dataUser.registerComplete]);

  useEffect(() => {
    if (
      dataLocalStorage?.email !== "default" &&
      dataLocalStorage?.email !== "" &&
      dataLocalStorage?.email !== undefined
    ) {
      //console.log("dataLocalStorage is TRUE:..",dataLocalStorage.email);
      //navigate('/retry');
      //window.location.reload();
    } else {
      //console.log("dataLocalStorage is FALSE:..",dataLocalStorage.email);
    }
  }, [dataLocalStorage]);

  useEffect(() => {
    if (dataMonitorLocalStorage?.user !== "") {
      console.log(
        "dataMonitorLocalStorage is TRUE:..",
        dataMonitorLocalStorage
      );
      setMonitorUser(dataMonitorLocalStorage);
      //navigate('/monitor');
      //window.location.reload();
    }
  }, [dataMonitorLocalStorage]);

  //933422631180070
  return (
    <FacebookProvider appId={id_face}>
      <GoogleOAuthProvider clientId={client_id}>
        <UserContext.Provider
          value={[
            dataUser,
            setDataUser,
            adminUser,
            setAdminUser,
            initialDataUser,
            dataLocalStorage,
            setDataLocalStorage,
            monitorUser,
            setMonitorUser,
            setDataMonitorLocalStorage,
            initialMonitorUser,
          ]}
        >
          <div>
            <HashRouter>
              <Routes>
                <Route path="/" element={<Lealtad />} />
                <Route path="/admin" element={<Admin />} />

                <Route path="/loginMonitor" element={<LoginMonitor />} />
                {dataMonitorLocalStorage.user !== "" && (
                  <>
                    <Route
                      path="/generalMonitor"
                      element={<GeneralMonitor />}
                    />
                    {dataMonitorLocalStorage.paises.includes("MX") && (
                      <>
                        <Route path="/monitor" element={<MonitorTiendas />} />
                        <Route
                          path="/customersMonitor"
                          element={<MonitorClients />}
                        />
                      </>
                    )}
                    {dataMonitorLocalStorage.role === "admin" && (
                      <>
                        <Route path="/adminMonitor" element={<AdminMonitor />} />
                      </>
                    )}
                  </>
                )}

                <Route path="/home" element={<Home />} />
                <Route path="/registro_express" element={<Express />} />
                <Route path="/retry" element={<RetryRegister />} />
                <Route
                  path="/retry_express"
                  element={<RetryRegisterExpress />}
                />
                <Route path="/welcome" element={<WelcomeMinisoLover />} />

                {/* <Route path="/consult" element={<Consulta/>}/> */}
                <Route path="*" element={<Error404 />} />
              </Routes>
            </HashRouter>
          </div>
        </UserContext.Provider>
      </GoogleOAuthProvider>
    </FacebookProvider>
  );
}

export default App;
